$(() => {
  const event_upload_input = $('#event-image-upload-input');

  // Handle Form Submit
  $('.event_form_submit').click(() => {
    if (!event_upload_input[0].files.length) {
      $('.custom-image-input').addClass('ERROR_FIELD');
    }
  });

  // Open Image Select box
  $('.upload-listing-image').click(() => {
    event_upload_input.trigger('click');
  });

  $('#clear_from_return').click(() => {
    // Clear Form
    $('form')[0].reset();
    window.location.pathname = window.Routes.account_path();
  });
});
